import GTextSelect from "../libs/textfield/GTextSelect";
import { ISelectRow } from "../libs/dropdown/Dropdown";
import Foods from "../data/Foods";
import { useMemo } from "react";
import FormGroup from "../libs/form/FormGroup";
import FormControl from "../libs/form/FormControl";

export interface IFoodListProps {
    index:number
    foodIds:number[]
    foodId:number
    error?:string
    onChange:(e:any, fodd:ISelectRow<number>|null) => void
}
export default function FoodList(props:IFoodListProps){
    const {index,foodIds} = props
    const Required = (val:ISelectRow<number>|undefined|null) => {
        return val ? null : "Ingredient is required"
    }
    const Duplicate = (val:ISelectRow<number>|undefined|null) => {
        if (!val) return null
        for(var i=0; i<foodIds.length; i++) {
            if (i!=index && foodIds[i]==val.value) {
                return "Duplicate ingredient"
            }
        }
        return null
    }
    const form = useMemo(() => new FormGroup("foods", [new FormControl("name", [Required, Duplicate])]), [])
    return <GTextSelect canClear={false} className="flex1" options={Foods.i.options} placeholder="Ingredient" 
        defaultValue={Foods.i.id2option(props.foodId)||undefined} onChange={props.onChange} form={form} controlName="name"/>
}